import React, { useState } from 'react';
import {
  Card, CardBody, ButtonToolbar,
} from 'reactstrap';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import { Tooltip } from '@material-ui/core';
import EmailOutlineIcon from 'mdi-react/EmailOutlineIcon';
import Button from '@material-ui/core/Button';
import ExportIcon from 'mdi-react/CloudDownloadIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@material-ui/core/styles';
import { matTheme } from '../../helpers/utils';
import CircleIcon from "mdi-react/CircleOutlineIcon";
import CheckCircleIcon from "mdi-react/CheckCircleOutlineIcon";
import { _hasPermission	} from "../../helpers/access";

const OwnerExportForm = ({ t, user, toggle, formValues, setFormValues, btnText, onSubmit }) => {
  
  const handleChange = (e) => {
	setFormValues({
	  ...formValues,
	  [e.target.name]: e.target.value,
	});
  };

  const handleTaskTypeChange = (formatType) => {
	setFormValues({
	  ...formValues,
	  formatType,
	});
  };

  const handleSubmit = (e) => {
	e.preventDefault();
	onSubmit(formValues);
  };
  
  let formatTypes = [{
	  type: "default",
	  icon: "https://marketproof.com/svgs/logo.svg",
	  text: "Default"
	}, {
		type: "studiopro",
		icon: "https://marketproof-hosting.s3.us-east-1.amazonaws.com/studiopro.png",
		text: "StudioPro by Rechat"
	  },{
	  type: "xpressdocs",
	  icon: "https://marketproof-hosting.s3.us-east-1.amazonaws.com/xd-logo.svg",
	  text: "Xpressdocs"
	}, {
	  type: "vistaprint",
	  icon: "https://marketproof-hosting.s3.us-east-1.amazonaws.com/VistaPrint_H_Color.png",
	  text: "VistaPrint"
	}];
	
  if(!_hasPermission(user, "studiopro")){
	  formatTypes = formatTypes.filter(f => f.type != "studiopro")
  }

  return (
	<form className="material-form" onSubmit={handleSubmit}>
	  <div>
		<p style={{ fontSize: 15 }} className="semi-bold-text mb-2">Name Your Owner List</p>
		<ThemeProvider theme={matTheme}>
		  <TextField
			className="material-form__field"
			name="exportName"
			value={formValues.exportName}
			onChange={handleChange}
			variant="outlined"
		  />
		</ThemeProvider>
	  </div>
		<p style={{ fontSize: 15 }} className="semi-bold-text mb-2">Choose Your Export Format</p>

	  <div className="button-options" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'space-between' }}>
		  {formatTypes.slice(0,3).map(({ type, icon, text }) => (
			<div 
			  key={type}
			  className={`account__btn-type ${formValues.formatType === type ? "selected" : ""}`} 
			  onClick={() => handleTaskTypeChange(type)}
			  style={{ flex: '1 1 22%', minHeight: '100px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border:formValues.formatType === type ? "1px solid #780F9E" : "1px solid #BFC4D1", background:formValues.formatType === type ? "#F5F7FA" : "",borderRadius:4,padding:"15px 5px", cursor:"pointer" }}
			>
			  {formValues.formatType === type ? (
				 <CheckCircleIcon color="#780F9E" size={32} />
			   ) : (
				 <CircleIcon color="#363347" size={32} />
			   )}
			  <div className="mt-2">
			  	<img src={`${icon}`} alt={text} style={{ width: '120px', height: 'auto' }} />
			  </div>
			  <div className="mt-2">
				<span className="semi-bold-text">{text}</span>
			  </div>
			</div>
		  ))}
		</div>
	  <hr/>
	  <p style={{ fontSize: 15 }}>
		You will receive an email when your export is ready for download.
	  </p>
	  <ButtonToolbar className="modal__footer" style={{ padding: 0 }}>
		<Tooltip title="Cancel">
		  <Button onClick={toggle} variant="outlined" style={{ marginRight: 10 }}>
			Cancel
		  </Button>
		</Tooltip>{' '}
		<Tooltip title="Confirm Data Export Request">
		  <Button
			type="submit"
			variant="contained"
			color="primary"
			className="buyersList__primary-button"
			startIcon={<ExportIcon />}
		  >
			{btnText || "Confirm Export"}
		  </Button>
		</Tooltip>
	  </ButtonToolbar>
	</form>
  );
};

OwnerExportForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  export_name: PropTypes.string,
  btnText: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default OwnerExportForm;
